import { DefaultTheme } from 'styled-components';

interface SelectorTheme {
    ({ theme }: { theme: DefaultTheme }): string
}

declare module 'styled-components' {
    export interface DefaultTheme {
        primary?: string,
        general?: string,
        font: {
            regular: string,
            semibold: string,
            bold: string,
        },
    }
}


export const modified = (modificator: Function) => 
    (selector: SelectorTheme) => 
        ({ theme }: { theme: DefaultTheme }) => 
            modificator(selector({ theme }));


const reserve: Required<DefaultTheme> = {
    general: '#162D3D',
    primary: '#2B81CB',
    font: {
        regular: 'Lato',
        semibold: 'Lato-Semibold',
        bold: 'Lato-Bold',
    },
}

export const safeGetPrimary: SelectorTheme = ({ theme }) => theme && theme.primary || reserve.primary;
export const safeGetGeneral: SelectorTheme = ({ theme }) => theme && theme.general || reserve.general;


export const safeGetFont = ({ theme }: { theme: DefaultTheme }) => theme && theme.font || reserve.font;

const safeFonts = 'Arial, sans-serif';
const withSafeFonts = (r: string) => `${r}, ${safeFonts}`;

export const regular = ({ theme }: { theme: DefaultTheme }) => withSafeFonts(safeGetFont({ theme }).regular);
export const semibold = ({ theme }: { theme: DefaultTheme }) => withSafeFonts(safeGetFont({ theme }).semibold);
export const bold = ({ theme }: { theme: DefaultTheme }) => withSafeFonts(safeGetFont({ theme }).bold);

export const connectFont = (fn: ({ theme }: { theme: DefaultTheme }) => string) => 
    (t: DefaultTheme) => fn({ theme: t });
